module.exports = __webpack_public_path__ + "static/media/lt-surge-6.ec4cbc99.wav";